import React from 'react'
import './SplashScreen.css'

/**
 * Full-screen splash screen displayed during app initialization
 * Shows logo with responsive image variants (1x and 2x pixel densities)
 */
const SplashScreen: React.FC = () => {
  return (
    <div className="splash-screen" data-testid="splash-screen">
      <div className="splash-content">
        <img
          src="/impact_by_xengolf_light.png"
          alt="Impact"
          className="splash-logo"
          width="200"
          height="54"
        />
      </div>
    </div>
  )
}

export default SplashScreen
